import logo from "@/assets/logo-libraddict.png";

interface LogoProps {
  className?: string;
  showText?: boolean;
}

export const Logo = ({ className = "", showText = true }: LogoProps) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img src={logo} alt="LIBR'ADDICT" className="h-8 w-auto shrink-0 md:h-10" />
      {showText && (
        <span className="font-bold text-sm whitespace-nowrap text-foreground md:text-xl">
          LIBR'ADDICT
        </span>
      )}
    </div>
  );
};
